module.exports = __webpack_public_path__ + "static/media/elephant_dice.238f9ce4.png";